import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/icons/shopping_bag.svg'


const _hoisted_1 = { class: "nav" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = { class: "bottom-nav" }
const _hoisted_4 = { class: "item-products" }
const _hoisted_5 = { class: "content-categories" }
const _hoisted_6 = { class: "items" }
const _hoisted_7 = { class: "rigth" }
const _hoisted_8 = { class: "categories" }
const _hoisted_9 = { href: "#" }
const _hoisted_10 = { class: "btn more-allproducts" }
const _hoisted_11 = { class: "aside aside-rigth" }
const _hoisted_12 = { class: "quantity-products" }
const _hoisted_13 = { class: "nav-mobile" }
const _hoisted_14 = { class: "nav-bar" }
const _hoisted_15 = { class: "quantity-products" }
const _hoisted_16 = {
  key: 0,
  class: "nav-menu__mobile"
}

import { useCartShoppingStore } from "@/store/cartshopping";
import categories from "@/data/categories.json";
import { faBars, faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { useRouter } from "vue-router";
import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'NavMain.component',
  setup(__props) {

const router = useRouter();
const cartShop = useCartShoppingStore();
const showMenuMobile = ref(false);

function navigateToCart() {
  router.push("/compra");
}
function onRedirectProducts() {
  router.push({ name: "productos" });
}

function toggleMenuMobile() {
  showMenuMobile.value = !showMenuMobile.value;
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("aside", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createElementVNode("img", {
            src: "https://res.cloudinary.com/dyikvzcke/image/upload/v1755469812/LOGO_SKF_1-removebg-preview_zfcosc.webp",
            alt: "Logo de Rodamientos Huanuco",
            class: "logo-max"
          }, null, -1),
          _createElementVNode("img", {
            src: "https://res.cloudinary.com/dyikvzcke/image/upload/v1755469968/LOGO_SKF_1_1_-removebg-preview_l56vp1.webp",
            alt: "Logo de Rodamientos Huanuco",
            class: "logo-min"
          }, null, -1)
        ]))]),
        _: 1
      })
    ]),
    _createElementVNode("aside", _hoisted_3, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("Inicio", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/acerca-de" }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("Acerca de", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("a", null, [
            _cache[4] || (_cache[4] = _createTextVNode("Productos   ", -1)),
            _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faCaretDown) }, null, 8, ["icon"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[5] || (_cache[5] = _createElementVNode("aside", { class: "left" }, [
                _createElementVNode("h4", null, "Categorias")
              ], -1)),
              _createElementVNode("aside", _hoisted_7, [
                _createElementVNode("ul", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories), (category) => {
                    return (_openBlock(), _createElementBlock("ul", {
                      key: category.id,
                      class: "subcategories"
                    }, [
                      _createVNode(_component_router_link, {
                        to: `/productos?categories=${category.id}`,
                        class: "text-category"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(category.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.subcategories, (subcategory) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: subcategory.id
                        }, [
                          _createElementVNode("a", _hoisted_9, _toDisplayString(subcategory.name), 1)
                        ]))
                      }), 128))
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (onRedirectProducts()))
              }, " Ver todos los productos ")
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("aside", _hoisted_11, [
      _cache[7] || (_cache[7] = _createElementVNode("button", { class: "btn btn-primmary" }, "Cotizar ahora", -1)),
      _createElementVNode("button", {
        class: "btn btn-shopping",
        onClick: navigateToCart
      }, [
        _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(cartShop).cart.length), 1),
        _cache[6] || (_cache[6] = _createElementVNode("img", {
          src: _imports_0,
          alt: "Icon carrito de compras"
        }, null, -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("button", { onClick: toggleMenuMobile }, [
          _createVNode(_unref(FontAwesomeIcon), {
            icon: _unref(faBars),
            size: "2x",
            style: {"color":"#2273b8"}
          }, null, 8, ["icon"])
        ]),
        _createElementVNode("button", {
          class: "btn btn-shopping",
          onClick: navigateToCart
        }, [
          _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(cartShop).cart.length), 1),
          _cache[8] || (_cache[8] = _createElementVNode("img", {
            src: _imports_0,
            alt: "Icon carrito de compras"
          }, null, -1))
        ])
      ]),
      (showMenuMobile.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode("Inicio", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/acerca-de" }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode("Acerca de", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/productos" }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode("Productos", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _cache[12] || (_cache[12] = _createElementVNode("button", { class: "btn btn-primmary" }, "Cotizar ahora", -1))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})